import { render, staticRenderFns } from "./ChatRightQuick.vue?vue&type=template&id=2caf5b28&"
import script from "./ChatRightQuick.vue?vue&type=script&lang=js&"
export * from "./ChatRightQuick.vue?vue&type=script&lang=js&"
import style0 from "./ChatRightQuick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports